<template>
  <v-row>
    <!-- Strategic KPIs -->
    <v-col cols="3">
      <metric-kpi metric="total_billing" interval="monthly" comparative="this_v_last_mtd" />
    </v-col>
    <v-col cols="3">
      <metric-kpi metric="total_mrr" interval="monthly" comparative="this_v_last" />
    </v-col>
    <v-col cols="3">
      <metric-kpi metric="total_arr" interval="monthly" comparative="this_v_last" />
    </v-col>
    <v-col cols="3">
      <metric-kpi metric="total_receivables_overdue" interval="monthly" comparative="this_v_last" />
    </v-col>

    <!-- Charts -->
    <v-col cols="6">
      <metric-graph metric="total_billing" />
    </v-col>
    <v-col cols="6">
      <metric-graph metric="net_growth_mrr" />
    </v-col>

    <!-- Operational health -->
    <v-col cols="12" class="px-0 pb-0">
      <v-toolbar color="transparent" flat height="55" dense>
        <v-toolbar-title class="pa-0 ml-n1 text--secondary subtitle-1 font-weight-medium">Salud operacional</v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col cols="4">
      <metric-kpi metric="unprocessed-subscriptions" interval="monthly" comparative="this_v_last" />
    </v-col>
    <v-col cols="4">
      <metric-kpi metric="unused-supporting-documents" interval="monthly" comparative="this_v_last" />
    </v-col>
    <v-col cols="4">
      <metric-kpi metric="expired-supporting-documents" interval="monthly" comparative="this_v_last" />
    </v-col>

    <!-- Top debtors -->
    <v-col cols="12" class="px-0 pb-0">
      <v-toolbar color="transparent" flat height="55" dense>
        <v-toolbar-title class="pa-0 ml-n1 text--secondary subtitle-1 font-weight-medium">Cuentas por cobrar</v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col cols="12">
      <metric-table metric="customer_debtor" />
    </v-col>
  </v-row>
</template>
<script>
import MetricKpi from '@/components/reports/MetricKpi'
import MetricGraph from '@/components/reports/MetricGraph'
import MetricTable from '@/components/reports/MetricTable'

export default {
  components: {
    MetricKpi,
    MetricGraph,
    MetricTable
  }
}
</script>
